import * as Sentry from "@sentry/react";
import { Integrations } from "@sentry/tracing";
import { FreshworksHelper } from "app/helpers/freshworksHelper";
import { SessionHelper } from "app/helpers/sessionHelper";
import { createBrowserHistory } from "history";
import { createRoot } from "react-dom/client";
import { IntlProvider } from "react-intl";
import { Provider } from "react-redux";
import { Router as ReactRouter } from "react-router-dom";
import "react-virtualized/styles.css";
import WebFont from "webfontloader";
import { LanguageSelectionHelper } from "../src/app/helpers/languageSelectionHelper";
import { addPageVisibleListener } from "./app/helpers/pageVisibility";
import VersionCheckHelper from "./app/helpers/versionCheckHelper";
// import following assets to force CRA to include them in build
import isPublicView from "app/utils/publicViewUtils";
import appleTouchIcon from "./app/images/favicon/apple-touch-icon.png";
import { SetupTranslations } from "./app/localization/translations";
import Router from "./app/screens/Router/Router";
import store from "./app/store/store";
import ThemeSelector from "./app/utils/ThemeSelector";
import ENV from "./config";
console.log("force assets into build", appleTouchIcon);
// import SentryRRWeb from "@sentry/rrweb";
if (ENV.SENTRY === "TRUE") {
  Sentry.init({
    dsn: "https://0d4af348e99747f5a1ee97f4b8592534@o510538.ingest.sentry.io/5606797",
    integrations: [
      new Integrations.BrowserTracing(), // new SentryRRWeb({
      //   // ...options
      // }),
    ],
    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
    debug: false,
    environment: ENV.DOMAIN,
    attachStacktrace: true,
    sendDefaultPii: false,
    release: ENV.RELEASE_VERSION,
    autoSessionTracking: true,
  });
}
//
if (ENV.CSS_THEME === "DEFAULT") {
  WebFont.load({
    google: {
      families: ["Source Sans Pro:400,600", "sans-serif"],
    },
  });
}

export const history: any = createBrowserHistory({
  basename: "/",
});
const element = document.getElementById("root");

if (!element) {
  throw new Error("couldn't find element with id root");
}

if (SessionHelper.isAuthenticated() || !isPublicView()) {
  FreshworksHelper.hideWidget();
}

// Setup translations and date/time
const language = LanguageSelectionHelper.checkSelectedLanguage();
const messages = SetupTranslations(language);
const container: any = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <IntlProvider locale={language} messages={messages}>
    <Provider store={store}>
      <ReactRouter history={history}>
        <ThemeSelector>
          <Router />
        </ThemeSelector>
      </ReactRouter>
    </Provider>
  </IntlProvider>
);

// Listen for when tab is selected/deselected, window minimised/maximised etc
addPageVisibleListener();

// Start polling to check if a newer version of the ui has been deployed
if (process.env.NODE_ENV && process.env.NODE_ENV === "production") {
  VersionCheckHelper.startPollingForVersion();
} // Let's skip the service worker for now
